<template>
  <f-dashboard-content-wrapper>
    <f-list
      :store="storeId"
      :query="query"
      :fuzzy="fuzzyOptions"
    >
      <template #list-actions="{ state }">
        <div class="is-grid is-aligned m-vertical-12">
          <div class="is-col-8 is-aligned">
            <f-input 
              v-model="state.search"
              placeholder="Recherche" 
            ></f-input>
          </div>

          <div class="is-col-4 is-aligned-right">
            <f-button-link 
              v-if="canCreate"
              :to="{ name: 'admin-create' }"
              size="small"
              fill
            >
              <i class="uil uil-plus"></i> Créer 
            </f-button-link>
          </div>
        </div>
      </template>

      <template #list-header="{ state, selectAll }">
        <admin-header>
          <template #select-all>
            <div class="is-centered m-horizontal-12">
              <f-checkbox 
                :model-value="state.allSelected"
                @change="selectAll"
              ></f-checkbox>
            </div>  
          </template>
        </admin-header>
      </template>

      <template #list-item="{ item, state, toggleSelection }">
        <admin-item
          :admin="item"
          :is-selected="state.selected.has(item._id)"
          @toggle-selection="toggleSelection"
        ></admin-item>
      </template>
    </f-list>
  </f-dashboard-content-wrapper>
</template>

<script>
  import { ref, computed, watch} from 'vue'
  import router from '@core/router'
  import useRoles from '@composables/use-roles'
  import AdminItem from './item/admin-item'
  import AdminHeader from './header/admin-header'

  export default {
    setup () {
      const { checkPermissions } = useRoles()

      const canCreate = computed(() => 
        checkPermissions('users:create')
      )

      const query = computed(() => {
        const filters = {}

        return {
          ...filters,
          $sort: {
            date: -1,
          },
        }
      })

      const storeId = ref('@admin/users')

      return { 
        canCreate,
        storeId,
        query,
        fuzzyOptions: {
          minMatchCharLength: 2,
          keys: ['email', 'firstname'],
        },
      }
    },

    components: {
      AdminItem,
      AdminHeader,
    },
  }
</script>